// 使用者 名稱 uid 星塵資訊
'use client';
import useCopy from '@/hooks/useCopy';
import useUrlStore from '@/store/useUrlStore';
import UserAvatar from '@/components/user/UserAvatar'; // 頭像

interface Props {
    user: any;
    type?: any;
}

const UserInfo = ({ user = {}, type }: Props) => {
    const { forumUrl } = useUrlStore();
    const { uid, image, avatarFrame, achievement, nickname, balance = 0 } = user || {};

    const copy = useCopy();

    const userPageUrl = `${forumUrl}/user/${uid}`;

    return (
        <div className="space-y-3 pb-3">
            <div className="py-2.5 flex items-center gap-x-3.5">
                {/* 頭像 */}
                <a
                    href={userPageUrl}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="shrink-0"
                >
                    <UserAvatar avatar={image} avatarFrame={avatarFrame} style="w-17.5" />
                </a>

                <div className="space-y-3 text-left min-w-0">
                    {/* 使用者名稱 */}
                    <a
                        target="_blank"
                        rel="noreferrer noopener"
                        href={userPageUrl}
                        className="text-btn3b text-black line-clamp-2"
                    >
                        {nickname}
                    </a>

                    {/* uid */}
                    <button className="text-bd3n text-purple8 opacity-80" onClick={() => copy(uid)}>
                        @{uid}
                    </button>
                </div>
            </div>

            {/* 側邊欄不顯示 */}
            {type !== 'aside' && (
                <div className="space-y-1.5 py-1.5">
                    <div className="flex between-center gap-x-0.5 text-black text-btn1">
                        <p>
                            持有星塵：<span className="text-btn1b text-vPurple">{balance}</span>
                        </p>

                        {/* 分隔線 */}
                        <span className="w-px h-3.5 border-l border-black2" />

                        {/* 登入天數 */}
                        <p>登入 {achievement?.loginDays} 天</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserInfo;
